import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';
import { RotatingSquare } from 'react-loader-spinner';

const StaffEdit = () => {
    const { id } = useParams();
    const [data, setData] = useState({});
    const [results, setResults] = useState({});

    const refSubmitDis = useRef();
    const [errorMessage, setErrorMessage] = useState({});



    const handleSubmitData = event => {
        event.preventDefault();

        refSubmitDis.current.setAttribute("disabled", true);
        setErrorMessage({});

        try {

            const formData = new FormData(event.currentTarget);
            const config = {
                headers: {
                    'content-type': 'application/json',
                }
            };
            axios.put(`https://api.velormall.com/api/admin/update/${id}`, formData, config)
                .then(response => {
                    event.target.reset();
                    toast.success(`${response?.data.message}`, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                    });
                    setResults(response?.data)
                    refSubmitDis.current.removeAttribute("disabled");
                }).catch((error) => {
                    setErrorMessage(error?.response?.data?.errors)
                    refSubmitDis.current.removeAttribute("disabled");
                });

        } catch (error) {

        }

    }



    useEffect(() => {
        fetch(`https://api.velormall.com/api/admin/view/${id}`, {
            method: 'GET',
        })
            .then((res) => res.json())
            .then((data) => {
                setData(data.data);
            })
    }, [results])



    return (
        <>
            <div className="d-flex mb-30 flex-wrap gap-3 justify-content-between align-items-center">
                <h6 className="page-title">Admin Update</h6>
                <div className="d-flex flex-wrap justify-content-end gap-2 align-items-center breadcrumb-plugins">
                </div>
            </div>

            <div className="row">
                <div className="col-lg-12 col-md-12 mb-30">
                    <div className="card">
                        <div className="card-body">
                            <form onSubmit={handleSubmitData}>
                                <div className="row">
                                    <div className=" col-md-12 ">
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label htmlFor="heading" className="required">Full Name </label>
                                                <input type="text" className="form-control" name="name" defaultValue={data?.name}  required="" id="heading" />
                                                {errorMessage?.name && (
                                                    <span className="text-danger pt-2">
                                                        {errorMessage?.name?.msg}
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label htmlFor="sub_heading" className="required">Email</label>
                                            <input type="email" className="form-control" name='email' defaultValue={data?.email}  required="" id="sub_heading" />
                                                {errorMessage?.email && (
                                                    <span className="text-danger pt-2">
                                                        {errorMessage?.email?.msg}
                                                    </span>
                                                )}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label htmlFor="password" className="required"> Password</label>
                                            <input type="password" className="form-control" name="password" defaultValue={data?.password}  required="" id="password" />
                                                {errorMessage?.password && (
                                                    <span className="text-danger pt-2">
                                                        {errorMessage?.password?.msg}
                                                    </span>
                                                )}
                                        </div>
                                    </div>

                                </div>


                                <div className="form-group">
                                    <button ref={refSubmitDis} type="submit" className="btn btn-primary w-100 h-45">Update</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );


};

export default StaffEdit;